import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme, Colors } from '@app/theme';
import { LabeledIconChip } from '@app/core';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.marginBase / 2,
  },
}));

interface Props {
  completion: number;
}

export const CompletionVisualiser = ({ completion }: Props) => {
  const classes = useStyles();
  const color: Colors =
    completion === 0 ? 'red' : completion === 100 ? 'green' : 'yellow';

  return (
    <div className={classes.container}>
      <LabeledIconChip chipLabel={completion + '%'} labelColor={color} />
    </div>
  );
};
